/* =====================================================================
   RYNOR – Bundle builder  (sections/bundle-builder.liquid)
   - Pieces load per category from /collections/<handle>?section_id=bundle-feed
   - Desktop: grid + "Your bundle" card. Mobile: bundle card, grid opens as a sheet
   - Pick my own / Best sellers / Shuffle (+ Undo, Clear with confirm)
   - Size pop-up (+ ring size guide), swap / change size / remove
   - Extras step -> duplicate check -> ONE /cart/add.js -> theme cart pop-out
   No dependencies.
   ===================================================================== */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('rynor-bundle-builder')) return;

  var STORAGE_DAYS = 7;
  var MAX_PAGES = 6;
  var HISTORY_MAX = 15;

  /* ------------------------------------------------------------------ */
  /* helpers                                                            */
  /* ------------------------------------------------------------------ */
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function noop() {}

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* strings from the section use [[name]] placeholders (curly braces break Liquid) */
  function tpl(str, vars) {
    return String(str || '').replace(/\[\[(\w+)\]\]/g, function (m, key) {
      return vars && vars[key] != null ? vars[key] : m;
    });
  }

  /* Shopify's t filter HTML-escapes translations (Don't -> Don&#39;t); decode before using as text */
  var entityBox = document.createElement('textarea');
  function decodeEntities(str) {
    if (typeof str !== 'string' || str.indexOf('&') < 0) return str;
    entityBox.innerHTML = str;
    return entityBox.value;
  }
  function decodeAll(obj) {
    Object.keys(obj || {}).forEach(function (k) {
      var v = obj[k];
      obj[k] = Array.isArray(v) ? v.map(decodeEntities) : decodeEntities(v);
    });
    return obj || {};
  }

  /* Size chart: one line per size, "14 = 54" = size 14 fits a 54 mm finger circumference.
     (If every value is under 30 the numbers are read as inner diameters instead.)
     -> [{ size: '14', c: 54 }] sorted by circumference */
  function parseChart(raw) {
    var rows = String(raw || '').split(/[\n;]+/).map(function (line) {
      var m = line.match(/^\s*([^=:]+?)\s*[=:]\s*(\d+(?:[.,]\d+)?)/);
      return m ? { size: m[1].trim(), v: parseFloat(m[2].replace(',', '.')) } : null;
    }).filter(function (r) { return r && r.v > 0; });
    var diameters = rows.length > 0 && rows.every(function (r) { return r.v < 30; });
    rows.forEach(function (r) { r.c = diameters ? r.v * Math.PI : r.v; });
    return rows.sort(function (a, b) { return a.c - b.c; });
  }

  function imgSize(url, width) {
    if (!url) return '';
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + width);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function shuffled(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function mq(query) {
    return window.matchMedia ? window.matchMedia(query) : { matches: false, addListener: noop };
  }
  var reduceMotion = mq('(prefers-reduced-motion: reduce)').matches;
  var mobileMq = mq('(max-width: 1023px)');
  var hoverMq = mq('(hover: hover) and (pointer: fine)');

  /* Money: learn the shop's format from one rendered sample (e.g. "$1,234,567.89") */
  function MoneyFormatter(sample) {
    var m = String(sample || '$1,234,567.89').match(/^(.*?)([\d.,\s\u00a0']*\d)(.*)$/);
    var prefix = m ? m[1] : '', run = m ? m[2] : '1,234,567.89', suffix = m ? m[3] : '';
    var digits = run.replace(/\D/g, '');
    var decimals = 0, decSep = '.', thouSep = ',';
    if (digits.slice(-2) === '89' && digits.length === 9) { decimals = 2; decSep = run.charAt(run.length - 3); }
    else if (digits.slice(-1) === '9' && digits.length === 8) { decimals = 1; decSep = run.charAt(run.length - 2); }
    var intPart = decimals ? run.slice(0, run.length - decimals - 1) : run;
    var sepMatch = intPart.match(/\D/);
    thouSep = sepMatch ? sepMatch[0] : '';
    function group(n) {
      var s = String(n), out = '';
      while (s.length > 3) { out = thouSep + s.slice(-3) + out; s = s.slice(0, -3); }
      return s + out;
    }
    this.format = function (cents, trimZeros) {
      cents = Math.round(Number(cents) || 0);
      var neg = cents < 0; if (neg) cents = -cents;
      var units = Math.floor(cents / 100), rem = cents % 100, out = group(units);
      if (decimals === 2 && !(trimZeros && rem === 0)) out += decSep + (rem < 10 ? '0' + rem : String(rem));
      else if (decimals === 1 && !(trimZeros && rem === 0)) out += decSep + String(Math.round(rem / 10));
      return (neg ? '-' : '') + prefix + out + suffix;
    };
  }

  /* ---------------- theme cart pop-out (WAU.AjaxCart, same as the quick-add) ---------------- */
  function themeCartConfig() {
    try {
      var el = document.getElementById('cart-config');
      if (el && el.textContent) return JSON.parse(el.textContent);
    } catch (e) {}
    return { cart_action: 'drawer' };
  }

  function hasThemeCart() {
    return !!(window.WAU && window.WAU.AjaxCart &&
      (typeof window.WAU.AjaxCart.showDrawer === 'function' || typeof window.WAU.AjaxCart.showModal === 'function'));
  }

  function openThemeCart() {
    var W = window.WAU;
    var tc = themeCartConfig();
    var step = Promise.resolve();
    try {
      if (W.ThemeCart && typeof W.ThemeCart.getCart === 'function' && typeof W.AjaxCart.updateView === 'function') {
        step = W.ThemeCart.getCart().then(function (cart) { return W.AjaxCart.updateView(tc, cart); });
      }
    } catch (e) {}
    return step.catch(noop).then(function () {
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      try {
        if (tc.cart_action === 'modal_cart' && typeof W.AjaxCart.showModal === 'function') W.AjaxCart.showModal(tc);
        else if (typeof W.AjaxCart.showDrawer === 'function') W.AjaxCart.showDrawer(Object.assign({}, tc, { cart_action: 'drawer' }));
      } catch (e) {}
    });
  }

  /* ------------------------------------------------------------------ */
  /* product normalisation                                              */
  /* ------------------------------------------------------------------ */
  var SIZE_WORDS = ['size', 'ring', 'accessory', 'talla', 'taille', 'größe', 'groesse', 'grösse', 'taglia', 'maat', 'length', 'longitud', 'longueur', 'länge', 'lunghezza', 'lengte'];
  var SILVER = ['silver', 'plata', 'argent', 'silber', 'zilver', 'argento', 'steel', 'stainless', 'white'];
  var GOLD = ['gold', 'oro', 'or ', 'goud', 'golden', 'dorado', 'doré', 'dore', '18k', '14k'];

  function metalOf(value) {
    var v = ' ' + String(value || '').toLowerCase() + ' ';
    var i;
    for (i = 0; i < GOLD.length; i++) if (v.indexOf(GOLD[i]) > -1) return 'gold';
    for (i = 0; i < SILVER.length; i++) if (v.indexOf(SILVER[i]) > -1) return 'silver';
    return null;
  }

  function normalizeProduct(raw) {
    var names = (raw.o || []).map(function (n) { return String(n || '').toLowerCase(); });
    var vs = raw.v || [];
    var sizeIdx = -1, metalIdx = -1, i, j;

    for (i = 0; i < names.length && sizeIdx < 0; i++) {
      for (j = 0; j < SIZE_WORDS.length; j++) {
        if (names[i].indexOf(SIZE_WORDS[j]) > -1) { sizeIdx = i; break; }
      }
    }
    for (i = 0; i < names.length && metalIdx < 0; i++) {
      if (i === sizeIdx) continue;
      var hits = 0;
      for (j = 0; j < vs.length; j++) if (metalOf(vs[j].o[i])) hits++;
      if (vs.length && hits >= vs.length / 2) metalIdx = i;
    }
    if (sizeIdx < 0) {
      for (i = 0; i < names.length; i++) {
        if (i === metalIdx) continue;
        var seen = {}, count = 0;
        for (j = 0; j < vs.length; j++) { var val = vs[j].o[i]; if (!seen[val]) { seen[val] = 1; count++; } }
        if (count > 1) { sizeIdx = i; break; }
      }
    }

    var variants = vs.map(function (v) {
      return {
        id: v.id, price: Number(v.p) || 0, available: !!v.a, sku: v.k || '', image: v.i || null,
        size: sizeIdx > -1 ? String(v.o[sizeIdx]) : null,
        metal: metalIdx > -1 ? metalOf(v.o[metalIdx]) : null,
        metalValue: metalIdx > -1 ? String(v.o[metalIdx]) : null
      };
    });
    var metals = {};
    variants.forEach(function (v) { if (v.metal) metals[v.metal] = true; });

    return {
      id: raw.id, handle: raw.h, title: raw.t, url: raw.u,
      tags: (raw.tg || []).map(function (t) { return String(t).toLowerCase(); }),
      available: !!raw.a, ts: raw.ts || '', gc: !!raw.gc, images: raw.im || [],
      variants: variants, hasSize: sizeIdx > -1, hasMetal: metalIdx > -1, metals: metals, cat: null
    };
  }

  function variantsFor(product, metal) {
    if (!product.hasMetal || !metal) return product.variants;
    return product.variants.filter(function (v) { return v.metal === metal; });
  }

  function sizeRange(variants) {
    var sizes = [];
    variants.forEach(function (v) { if (v.size && sizes.indexOf(v.size) < 0) sizes.push(v.size); });
    return sizes;
  }

  function lowestPrice(variants) {
    var p = null;
    variants.forEach(function (v) { if (p === null || v.price < p) p = v.price; });
    return p || 0;
  }

  /* [main image, second image] for the chosen metal (never shows the other metal's photo second) */
  function imagesFor(product, metal) {
    var list = variantsFor(product, metal);
    var first = null, i;
    for (i = 0; i < list.length; i++) if (list[i].image) { first = list[i].image; break; }
    if (!first) first = product.images[0] || '';
    var other = {};
    if (product.hasMetal && metal) {
      product.variants.forEach(function (v) { if (v.metal && v.metal !== metal && v.image) other[v.image.split('?')[0]] = 1; });
    }
    var second = '';
    var base = first.split('?')[0];
    for (i = 0; i < product.images.length; i++) {
      var im = product.images[i], key = im.split('?')[0];
      if (key !== base && !other[key]) { second = im; break; }
    }
    return [first, second];
  }

  /* ------------------------------------------------------------------ */
  /* element                                                            */
  /* ------------------------------------------------------------------ */
  function RynorBundleBuilder() {
    return Reflect.construct(HTMLElement, [], RynorBundleBuilder);
  }
  RynorBundleBuilder.prototype = Object.create(HTMLElement.prototype);
  RynorBundleBuilder.prototype.constructor = RynorBundleBuilder;
  Object.setPrototypeOf(RynorBundleBuilder, HTMLElement);
  var proto = RynorBundleBuilder.prototype;

  proto.connectedCallback = function () {
    if (this._ready) { if (!this._dockOff) this.initDock(); return; }
    var cfgEl = this.querySelector('[data-rbb-config]');
    if (!cfgEl) return;
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[rynor-bundle] bad config', e); return; }
    this._ready = true;

    var cfg = this.cfg;
    this.i18n = decodeAll(cfg.i18n);
    this.money = new MoneyFormatter(cfg.moneySample);
    this.required = Math.max(1, cfg.required || 7);
    this.products = {};
    this.byId = {};
    this.slots = [];
    for (var i = 0; i < this.required; i++) this.slots.push(null);
    this.active = 0;
    this.swapping = -1;
    this.cat = 0;
    this.sub = '';
    this.metal = cfg.defaultMetal || 'silver';
    this.mode = 'pick';
    this.history = [];
    this.modalStack = [];
    this.pickerOpen = false;
    this.busy = false;
    this.pool = {};
    this.boxVariant = null;

    this.el = {
      live: this.q('[data-live]'),
      picker: this.q('[data-picker]'),
      pickerBody: this.q('[data-picker-body]'),
      grid: this.q('[data-grid]'),
      status: this.q('[data-status]'),
      meta: this.q('[data-meta]'),
      subs: this.q('[data-subs]'),
      metalToggle: this.q('[data-metal-toggle]'),
      swapbar: this.q('[data-swapbar]'),
      swapText: this.q('[data-swap-text]'),
      slots: this.q('[data-slots]'),
      count: this.q('[data-count]'),
      sheetCount: this.q('[data-sheet-count]'),
      tools: this.q('[data-tools]'),
      undo: this.q('[data-undo]'),
      clear: this.q('[data-clear]'),
      retail: this.q('[data-retail]'),
      price: this.q('[data-price]'),
      pp: this.q('[data-pp]'),
      save: this.q('[data-save]'),
      cta: this.q('[data-cta]'),
      msg: this.q('[data-msg]'),
      build: this.q('[data-view="build"]'),
      extras: this.q('[data-view="extras"]'),
      xMsg: this.q('[data-x-msg]'),
      addBox: this.q('[data-add-box]'),
      skip: this.q('[data-skip]')
    };

    this.restore();
    this.bind();
    this.renderSlots();
    this.renderPrice();
    this.renderModes();
    if (this.el.grid) this.selectCategory(0);
    document.body.classList.add('rbb-page');
    this.initDock();

    var wantExtras = (window.location.hash === '#extras' && this.isComplete()) ||
      (window.Shopify && window.Shopify.designMode && this.getAttribute('data-preview-extras') === 'true');
    if (wantExtras) this.showExtras(false);
  };

  proto.disconnectedCallback = function () {
    if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
    if (this._onKey) document.removeEventListener('keydown', this._onKey);
    if (this._onPop) window.removeEventListener('popstate', this._onPop);
    if (this._onResize) window.removeEventListener('resize', this._onResize);
    if (this._dockOff) { this._dockOff(); this._dockOff = null; }
    document.body.classList.remove('rbb-page', 'rbb-lock', 'rbb-sheet-open');
  };

  proto.q = function (sel) { return this.querySelector(sel); };
  proto.isMobile = function () { return !!mobileMq.matches; };

  /* ---------------- persistence ---------------- */
  proto.restore = function () {
    var raw;
    try { raw = window.localStorage.getItem(this.cfg.storageKey); } catch (e) { return; }
    if (!raw) return;
    try {
      var data = JSON.parse(raw);
      var fresh = data && Date.now() - (data.ts || 0) < STORAGE_DAYS * 864e5;
      if (!fresh || !Array.isArray(data.slots) || (data.currency && data.currency !== this.cfg.currency)) {
        this.clearStored();
        return;
      }
      for (var i = 0; i < this.required; i++) {
        var s = data.slots[i];
        this.slots[i] = s && s.vid ? s : null;
      }
      if (data.mode === 'best' || data.mode === 'shuffle') this.mode = data.mode;
      this.active = this.firstEmpty();
    } catch (e) { this.clearStored(); }
  };

  proto.persist = function () {
    try {
      window.localStorage.setItem(this.cfg.storageKey, JSON.stringify({
        v: 2, ts: Date.now(), currency: this.cfg.currency, mode: this.mode, slots: this.slots
      }));
    } catch (e) {}
  };

  proto.clearStored = function () {
    try { window.localStorage.removeItem(this.cfg.storageKey); } catch (e) {}
  };

  /* ---------------- small state helpers ---------------- */
  proto.count = function () { return this.slots.filter(Boolean).length; };
  proto.pendingSizes = function () { return this.slots.filter(function (s) { return s && s.needsSize; }).length; };
  proto.isComplete = function () { return this.count() === this.required && this.pendingSizes() === 0; };
  proto.firstEmpty = function () {
    for (var i = 0; i < this.slots.length; i++) if (!this.slots[i]) return i;
    return -1;
  };
  proto.retailTotal = function () {
    return this.slots.reduce(function (sum, s) { return sum + (s ? Number(s.price) || 0 : 0); }, 0);
  };
  proto.timesInBundle = function (pid) {
    return this.slots.filter(function (s) { return s && String(s.pid) === String(pid); }).length;
  };
  proto.say = function (text) {
    var live = this.el.live;
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 30);
  };
  proto.flash = function (text, kind) {
    var el = this.el.msg;
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', kind === 'error');
    el.classList.toggle('is-ok', kind === 'ok');
    clearTimeout(this._flashT);
    if (text) this._flashT = setTimeout(function () { el.textContent = ''; el.classList.remove('is-error', 'is-ok'); }, 4200);
  };
  proto.afterChange = function () {
    this.persist();
    this.renderSlots();
    this.renderPrice();
    this.renderModes();
    this.refreshCardStates();
  };
  proto.lockCheck = function () {
    document.body.classList.toggle('rbb-lock', this.pickerOpen || this.modalStack.length > 0);
    document.body.classList.toggle('rbb-sheet-open', this.pickerOpen);
  };

  /* ------------------------------------------------------------------ */
  /* events                                                             */
  /* ------------------------------------------------------------------ */
  proto.bind = function () {
    var self = this;

    var cats = this.q('[data-cats]');
    if (cats) {
      cats.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cat]');
        if (b) self.selectCategory(parseInt(b.getAttribute('data-cat'), 10));
      });
      cats.addEventListener('keydown', function (e) { self.tabKeys(e, '[data-cat]', function (b) { self.selectCategory(parseInt(b.getAttribute('data-cat'), 10)); }); });
    }

    if (this.el.subs) {
      this.el.subs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sub]');
        if (b) self.selectSub(b.getAttribute('data-sub'));
      });
      this.el.subs.addEventListener('keydown', function (e) { self.tabKeys(e, '[data-sub]', function (b) { self.selectSub(b.getAttribute('data-sub')); }); });
    }

    if (this.el.metalToggle) {
      this.el.metalToggle.addEventListener('click', function (e) {
        var b = e.target.closest('[data-metal]');
        if (!b || b.getAttribute('aria-pressed') === 'true') return;
        self.metal = b.getAttribute('data-metal');
        toArray(self.el.metalToggle.querySelectorAll('[data-metal]')).forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        self.renderGrid();
      });
    }

    var grid = this.el.grid;
    if (grid) {
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-add]');
        if (!b || b.disabled) return;
        var card = b.closest('[data-pid]');
        if (card && !card.classList.contains('is-soldout')) self.wantToAdd(card.getAttribute('data-pid'), b);
      });
      grid.addEventListener('scroll', function (e) {
        var t = e.target;
        if (!t || !t.matches || !t.matches('[data-track]')) return;
        var idx = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        toArray(t.parentNode.querySelectorAll('.rbb-card__dots i')).forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      }, true);
      grid.addEventListener('mouseover', function (e) { self.hoverSwap(e, true); });
      grid.addEventListener('mouseout', function (e) { self.hoverSwap(e, false); });
    }

    var swapCancel = this.q('[data-swap-cancel]');
    if (swapCancel) swapCancel.addEventListener('click', function () { self.cancelSwap(); });

    if (this.el.slots) {
      this.el.slots.addEventListener('click', function (e) {
        var b = e.target.closest('[data-act]');
        if (!b) return;
        var idx = parseInt(b.getAttribute('data-idx'), 10);
        var act = b.getAttribute('data-act');
        e.stopPropagation();
        if (act === 'menu') self.toggleMenu(idx);
        else if (act === 'size') { self.closeMenus(); self.openSizeFor(idx, b); }
        else if (act === 'swap') self.startSwap(idx);
        else if (act === 'remove') self.removeSlot(idx);
        else if (act === 'empty') self.pickSlot(idx);
      });
    }
    this._onDocClick = function (e) { if (!e.target.closest('.rbb-slot')) self.closeMenus(); };
    document.addEventListener('click', this._onDocClick);

    toArray(this.querySelectorAll('[data-mode]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var m = b.getAttribute('data-mode');
        if (m === 'pick') self.pickOwn();
        else if (m === 'best') self.fillBest(b);
        else if (m === 'shuffle') self.shuffle(b);
      });
    });
    if (this.el.undo) this.el.undo.addEventListener('click', function () { self.undo(); });
    if (this.el.clear) this.el.clear.addEventListener('click', function () {
      self.confirmClear(null, function () { self.clearSlots(); });
    });

    toArray(this.querySelectorAll('[data-picker-close]')).forEach(function (b) {
      b.addEventListener('click', function () { self.closePicker(); });
    });

    if (this.el.cta) {
      this.el.cta.addEventListener('click', function () {
        if (self.count() < self.required) { self.flash(self.i18n.incomplete, 'error'); return; }
        if (self.pendingSizes() > 0) {
          for (var i = 0; i < self.slots.length; i++) if (self.slots[i] && self.slots[i].needsSize) { self.openSizeFor(i, self.el.cta); return; }
        }
        if (self.cfg.box) self.showExtras(true);
        else self.beforeCheckout(false, self.el.cta);
      });
    }

    if (this.el.addBox) this.el.addBox.addEventListener('click', function () { self.beforeCheckout(true, self.el.addBox); });
    if (this.el.skip) this.el.skip.addEventListener('click', function () { self.beforeCheckout(false, self.el.skip); });
    toArray(this.querySelectorAll('[data-back]')).forEach(function (b) {
      b.addEventListener('click', function () { self.showBuild(true); });
    });

    var colors = this.q('[data-box-colors]');
    if (colors) {
      colors.addEventListener('click', function (e) {
        var b = e.target.closest('[data-vid]');
        if (b) self.selectBoxVariant(b.getAttribute('data-vid'));
      });
    }

    var openReviews = this.q('[data-open-reviews]');
    if (openReviews) openReviews.addEventListener('click', function () { self.openReviews(openReviews); });
    var track = this.q('[data-rv-track]');
    var thumb = this.q('[data-rv-thumb]');
    if (track && thumb) {
      var syncBar = function () {
        var max = track.scrollWidth - track.clientWidth;
        var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        thumb.style.width = Math.max(12, Math.min(100, ratio * 100)) + '%';
        thumb.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - Math.min(100, ratio * 100)) : 0) + '%';
        thumb.parentNode.hidden = ratio >= 0.999;
      };
      track.addEventListener('scroll', syncBar, { passive: true });
      window.addEventListener('resize', debounce(syncBar, 150));
      this._syncBar = syncBar;
      syncBar();
    }

    toArray(this.querySelectorAll('[data-modal]')).forEach(function (m) {
      toArray(m.querySelectorAll('[data-close]')).forEach(function (b) {
        b.addEventListener('click', function () { self.closeModal(m); });
      });
    });

    var szpSizes = this.q('[data-szp-sizes]');
    if (szpSizes) {
      szpSizes.addEventListener('click', function (e) {
        var b = e.target.closest('[data-size-vid]');
        if (b && !b.disabled) self.chooseSize(b.getAttribute('data-size-vid'));
      });
      szpSizes.addEventListener('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        var btns = toArray(szpSizes.querySelectorAll('button:not(:disabled)'));
        var i = btns.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var next = btns[(i + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1) + btns.length) % btns.length];
        next.focus();
        self.chooseSize(next.getAttribute('data-size-vid'));
      });
    }
    var szpSave = this.q('[data-szp-save]');
    if (szpSave) szpSave.addEventListener('click', function () { self.saveSize(); });
    var szpGuide = this.q('[data-szp-guide]');
    if (szpGuide) szpGuide.addEventListener('click', function () { self.openGuide(szpGuide); });
    var guideBack = this.q('[data-guide-back]');
    if (guideBack) guideBack.addEventListener('click', function () { self.guideBack(); });
    this.initGuide();

    var keep = this.q('[data-clear-keep]');
    if (keep) keep.addEventListener('click', function () { self.resolveClear(false); });
    var clr = this.q('[data-clear-confirm]');
    if (clr) clr.addEventListener('click', function () { self.resolveClear(true); });

    var dChange = this.q('[data-dupe-change]');
    if (dChange) dChange.addEventListener('click', function () {
      self.closeModal(self.q('[data-modal="dupes"]'));
      self.showBuild(true);
    });
    var dGo = this.q('[data-dupe-continue]');
    if (dGo) dGo.addEventListener('click', function () {
      self.closeModal(self.q('[data-modal="dupes"]'));
      self.addToCart(self._pendingBox, self._pendingTrigger);
    });

    this._onKey = function (e) {
      var top = self.modalStack[self.modalStack.length - 1];
      if (e.key === 'Escape') {
        if (top) { self.closeModal(top); return; }
        if (self.pickerOpen) { self.closePicker(); return; }
        if (self.swapping > -1) { self.cancelSwap(); return; }
        self.closeMenus();
        return;
      }
      if (e.key === 'Tab') {
        var box = top ? top.querySelector('.rbb-modal__panel') : (self.pickerOpen ? self.el.picker : null);
        if (box) self.trapFocus(e, box);
      }
    };
    document.addEventListener('keydown', this._onKey);

    this._onPop = function () {
      if (window.location.hash === '#extras' && self.isComplete() && self.cfg.box) self.showExtras(false);
      else self.showBuild(false);
    };
    window.addEventListener('popstate', this._onPop);

    this._onResize = debounce(function () { if (self.pickerOpen && !self.isMobile()) self.closePicker(true); }, 150);
    window.addEventListener('resize', this._onResize);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var tab = e.target && e.target.closest && e.target.closest('[data-cat]');
        if (tab && self.contains(tab)) self.selectCategory(parseInt(tab.getAttribute('data-cat'), 10));
      });
    }
  };

  proto.tabKeys = function (e, sel, activate) {
    var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (keys.indexOf(e.key) < 0) return;
    var tabs = toArray(e.currentTarget.querySelectorAll(sel));
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    var n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowLeft' ? -1 : 1) + tabs.length) % tabs.length;
    tabs[n].focus();
    activate(tabs[n]);
  };

  proto.trapFocus = function (e, box) {
    var f = toArray(box.querySelectorAll('button:not(:disabled), a[href], [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  };

  proto.hoverSwap = function (e, enter) {
    // html.ry-mouse = a real mouse on a PC that Chrome reports as touch-only (layout/theme.liquid)
    if (!hoverMq.matches && !document.documentElement.classList.contains('ry-mouse')) return;
    var media = e.target.closest && e.target.closest('.rbb-card__media');
    if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
    var track = media.querySelector('[data-track]');
    if (!track || track.children.length < 2) return;
    track.scrollTo({ left: enter ? track.clientWidth : 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  /* ------------------------------------------------------------------ */
  /* categories + loading                                               */
  /* ------------------------------------------------------------------ */
  proto.skeleton = function () {
    var html = '';
    for (var i = 0; i < 12; i++) {
      html += '<div class="rbb-card rbb-card--skel" aria-hidden="true"><div class="rbb-card__media"></div><div class="rbb-card__body"><span></span><span></span></div></div>';
    }
    return html;
  };

  proto.selectCategory = function (index) {
    var cats = this.cfg.categories || [];
    if (!cats[index] || !this.el.grid) return;
    this.cat = index;
    this.sub = '';
    toArray(this.querySelectorAll('[data-cat]')).forEach(function (b) {
      var on = parseInt(b.getAttribute('data-cat'), 10) === index;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
      if (on && b.scrollIntoView && b.parentNode.scrollWidth > b.parentNode.clientWidth) {
        b.parentNode.scrollLeft = b.offsetLeft - 12;
      }
    });

    var entry = this.products[index];
    if (entry && entry.first) {
      this.renderSubs();
      this.renderGrid();
      return;
    }
    var self = this;
    this.el.grid.setAttribute('aria-busy', 'true');
    this.el.grid.innerHTML = this.skeleton();
    if (this.el.status) this.el.status.hidden = true;
    this.renderMeta();
    this.ensureCategory(index).then(function () {
      if (self.cat !== index) return;
      self.renderSubs();
      self.renderGrid();
    }).catch(function () {
      if (self.cat !== index) return;
      self.el.grid.setAttribute('aria-busy', 'false');
      self.el.grid.innerHTML = '';
      self.setStatus(self.i18n.loadError);
    });
  };

  proto.ensureCategory = function (index) {
    var self = this;
    var cat = (this.cfg.categories || [])[index];
    if (!cat) return Promise.reject(new Error('no category'));
    var entry = this.products[index];
    if (entry && entry.promise) return entry.promise;
    entry = this.products[index] = { list: [], first: false, done: false };
    entry.promise = this.loadPage(cat.feed, 1).then(function (data) {
      self.ingest(index, data.products);
      entry.first = true;
      self.loadRest(index, cat, data.pages || 1);
      return entry;
    });
    entry.promise.catch(function () { if (self.products[index] === entry) delete self.products[index]; });
    return entry.promise;
  };

  proto.loadPage = function (feed, page) {
    var url = feed + (feed.indexOf('?') > -1 ? '&' : '?') + 'page=' + page;
    var store = window.__rynorBundlePrefetch || {};
    var req;
    if (page === 1 && store[url]) { req = store[url]; delete store[url]; }
    else {
      req = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
    }
    return req.then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector('[data-bundle-feed]');
      if (!node) throw new Error('feed missing');
      return JSON.parse(node.textContent);
    });
  };

  proto.ingest = function (index, rawList) {
    var entry = this.products[index];
    var self = this;
    var added = [];
    (rawList || []).forEach(function (raw) {
      if (!raw || !raw.v || !raw.v.length) return;
      var p = self.byId[raw.id] || normalizeProduct(raw);
      if (p.cat === null) p.cat = index;
      self.byId[p.id] = p;
      if (entry && !entry.list.some(function (x) { return x.id === p.id; })) { entry.list.push(p); added.push(p); }
    });
    return added;
  };

  proto.loadRest = function (index, cat, pages) {
    var self = this;
    var entry = this.products[index];
    var last = Math.min(pages, MAX_PAGES);
    if (last < 2) { entry.done = true; return; }
    var chain = Promise.resolve();
    for (var p = 2; p <= last; p++) {
      (function (page) {
        chain = chain.then(function () {
          return self.loadPage(cat.feed, page).then(function (data) {
            var added = self.ingest(index, data.products);
            if (self.cat === index && added.length) {
              self.renderSubs();
              self.insertCards(added);
            }
          });
        });
      })(p);
    }
    chain.catch(noop).then(function () { entry.done = true; });
  };

  proto.loadAllCategories = function () {
    var self = this;
    var jobs = (this.cfg.categories || []).map(function (c, i) {
      return self.ensureCategory(i).catch(function () { return null; });
    });
    return Promise.all(jobs);
  };

  proto.eligible = function (p) {
    if (!p || !p.available || p.gc) return false;
    var cfg = this.cfg;
    if (cfg.bundle && String(p.id) === String(cfg.bundle.id)) return false;
    if (cfg.box && String(p.id) === String(cfg.box.id)) return false;
    if (p.ts && /bundle/i.test(p.ts)) return false;
    return p.variants.some(function (v) { return v.available; });
  };

  /* ---------------- filters ---------------- */
  proto.matchesSub = function (p, tag) {
    if (!tag) return true;
    var t = tag.toLowerCase();
    if (p.tags.indexOf(t) > -1) return true;
    return (' ' + p.title.toLowerCase() + ' ').indexOf(' ' + t) > -1;
  };

  proto.renderSubs = function () {
    var box = this.el.subs;
    var cat = (this.cfg.categories || [])[this.cat];
    var entry = this.products[this.cat];
    if (!box || !cat || !entry) return;
    var self = this;
    var filters = (cat.filters || []).filter(function (f) {
      return entry.list.some(function (p) { return self.matchesSub(p, f.tag); });
    });
    if (!filters.length) { box.hidden = true; box.innerHTML = ''; return; }
    var html = '<button type="button" role="tab" class="rbb-sub" data-sub="" aria-selected="' + (self.sub ? 'false' : 'true') + '" tabindex="' + (self.sub ? '-1' : '0') + '">' + esc(this.i18n.all) + '</button>';
    filters.forEach(function (f) {
      var on = self.sub === f.tag;
      html += '<button type="button" role="tab" class="rbb-sub" data-sub="' + esc(f.tag) + '" aria-selected="' + on + '" tabindex="' + (on ? '0' : '-1') + '">' + esc(f.label) + '</button>';
    });
    box.innerHTML = html;
    box.hidden = false;
  };

  proto.selectSub = function (tag) {
    this.sub = tag || '';
    toArray(this.el.subs.querySelectorAll('[data-sub]')).forEach(function (b) {
      var on = b.getAttribute('data-sub') === tag;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    this.renderGrid();
  };

  proto.soldOut = function (p) {
    if (!p.available) return true;
    return !variantsFor(p, this.metal).some(function (v) { return v.available; });
  };

  proto.visibleProducts = function () {
    var entry = this.products[this.cat];
    if (!entry) return [];
    var self = this;
    var list = entry.list.filter(function (p) {
      if (!self.matchesSub(p, self.sub)) return false;
      if (p.hasMetal && !p.metals[self.metal]) return false;
      return true;
    });
    var ok = [], out = [];
    list.forEach(function (p) { (self.soldOut(p) ? out : ok).push(p); });
    return ok.concat(out);
  };

  proto.renderMeta = function () {
    var cat = (this.cfg.categories || [])[this.cat];
    if (!this.el.meta || !cat) return;
    var entry = this.products[this.cat];
    var n = entry && entry.done ? entry.list.length : cat.count;
    var text = tpl(this.i18n.pieceCount, { number: n, label: cat.label });
    if (this.cfg.sortLabel) text += ' · ' + this.i18n.bestSelling;
    this.el.meta.textContent = text;
  };

  proto.setStatus = function (text) {
    if (!this.el.status) return;
    this.el.status.textContent = text || '';
    this.el.status.hidden = !text;
  };

  proto.renderGrid = function () {
    var grid = this.el.grid;
    if (!grid) return;
    var entry = this.products[this.cat];
    this.renderMeta();
    var hasMetals = entry && entry.list.some(function (p) { return p.hasMetal; });
    if (this.el.metalToggle) this.el.metalToggle.hidden = !hasMetals;
    var list = this.visibleProducts();
    grid.setAttribute('aria-busy', 'false');
    grid.innerHTML = list.map(this.cardHtml, this).join('');
    if (!list.length) {
      var metalName = this.metal === 'gold' ? this.i18n.metalGold : this.i18n.metalSilver;
      this.setStatus(hasMetals && !this.sub ? tpl(this.i18n.noMetal, { metal: metalName }) : this.i18n.empty);
    } else {
      this.setStatus('');
    }
  };

  /* new pieces from later pages: available ones go before the first sold-out card */
  proto.insertCards = function (products) {
    var grid = this.el.grid;
    var self = this;
    var visible = products.filter(function (p) {
      return self.matchesSub(p, self.sub) && (!p.hasMetal || p.metals[self.metal]);
    });
    if (!visible.length) return;
    var firstSold = grid.querySelector('.rbb-card.is-soldout');
    visible.forEach(function (p) {
      var wrap = document.createElement('div');
      wrap.innerHTML = self.cardHtml(p);
      var card = wrap.firstChild;
      if (!self.soldOut(p) && firstSold) grid.insertBefore(card, firstSold);
      else grid.appendChild(card);
    });
    this.setStatus('');
    this.renderMeta();
  };

  proto.cardHtml = function (p) {
    var list = variantsFor(p, this.metal);
    var sizes = sizeRange(list);
    var soldOut = this.soldOut(p);
    var n = this.timesInBundle(p.id);
    var imgs = imagesFor(p, this.metal);
    var price = lowestPrice(list);
    var sizeText = sizes.length > 1 ? tpl(this.i18n.sizesRange, { range: sizes[0] + '–' + sizes[sizes.length - 1] }) : this.i18n.oneSize;
    var title = esc(p.title);

    var media = '<div class="rbb-card__track" data-track>';
    media += imgs[0]
      ? '<img src="' + esc(imgSize(imgs[0], 480)) + '" srcset="' + esc(imgSize(imgs[0], 320)) + ' 320w, ' + esc(imgSize(imgs[0], 480)) + ' 480w, ' + esc(imgSize(imgs[0], 720)) + ' 720w" sizes="(min-width: 1280px) 220px, (min-width: 768px) 25vw, 33vw" alt="' + title + '" loading="lazy" width="480" height="600">'
      : '';
    if (imgs[1]) media += '<img src="' + esc(imgSize(imgs[1], 480)) + '" alt="" loading="lazy" width="480" height="600">';
    media += '</div>';
    if (imgs[1]) media += '<span class="rbb-card__dots" aria-hidden="true"><i class="is-on"></i><i></i></span>';
    if (soldOut) media += '<span class="rbb-card__flag">' + esc(this.i18n.soldOut) + '</span>';
    else if (n) media += '<span class="rbb-card__qty">' + (n > 1 ? '×' + n : '✓') + '</span>';

    var btnLabel = soldOut ? this.i18n.soldOut : (n ? this.i18n.inBundle + (n > 1 ? ' ×' + n : '') : this.i18n.add);
    var dis = soldOut ? ' disabled' : '';

    return '<div class="rbb-card' + (soldOut ? ' is-soldout' : '') + (n ? ' is-in' : '') + '" role="listitem" data-pid="' + esc(p.id) + '">' +
      '<div class="rbb-card__media" data-add>' + media +
        '<button type="button" class="rbb-card__plus" data-add aria-label="' + esc(this.i18n.add) + ': ' + title + '"' + dis + '>' +
          '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.6"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="rbb-card__body">' +
        '<div class="rbb-card__info">' +
          '<span class="rbb-card__name" title="' + title + '">' + title + '</span>' +
          '<span class="rbb-card__meta">' + esc(sizeText) + '</span>' +
          (price ? '<span class="rbb-card__price"><s>' + esc(this.money.format(price, true)) + '</s></span>' : '') +
        '</div>' +
        '<button type="button" class="rbb-card__btn" data-add aria-label="' + esc(this.i18n.add) + ': ' + title + '"' + dis + '>' + esc(btnLabel) + '</button>' +
      '</div>' +
    '</div>';
  };

  proto.refreshCardStates = function () {
    if (!this.el.grid) return;
    var self = this;
    toArray(this.el.grid.querySelectorAll('[data-pid]')).forEach(function (card) {
      if (card.classList.contains('is-soldout')) return;
      var n = self.timesInBundle(card.getAttribute('data-pid'));
      card.classList.toggle('is-in', n > 0);
      var chip = card.querySelector('.rbb-card__qty');
      if (n && !chip) {
        chip = document.createElement('span');
        chip.className = 'rbb-card__qty';
        card.querySelector('.rbb-card__media').appendChild(chip);
      }
      if (chip) { if (n) chip.textContent = n > 1 ? '×' + n : '✓'; else chip.parentNode.removeChild(chip); }
      var btn = card.querySelector('.rbb-card__btn');
      if (btn) btn.textContent = n ? self.i18n.inBundle + (n > 1 ? ' ×' + n : '') : self.i18n.add;
    });
  };

  /* ------------------------------------------------------------------ */
  /* adding pieces                                                      */
  /* ------------------------------------------------------------------ */
  proto.targetSlot = function () {
    if (this.swapping > -1) return this.swapping;
    if (this.active > -1 && !this.slots[this.active]) return this.active;
    return this.firstEmpty();
  };

  proto.wantToAdd = function (pid, opener) {
    var p = this.byId[pid];
    if (!p) return;
    var slot = this.targetSlot();
    if (slot < 0) { this.flash(this.i18n.bundleFull, 'error'); this.say(this.i18n.bundleFull); return; }
    var list = variantsFor(p, this.metal).filter(function (v) { return v.available; });
    if (!list.length) return;
    if (sizeRange(list).length > 1) {
      this.openSizeModal(p, { slot: slot, variants: variantsFor(p, this.metal), current: null, opener: opener, update: false });
    } else {
      this.placePiece(p, list[0], slot);
    }
  };

  proto.pieceFrom = function (p, v) {
    return {
      pid: p.id, handle: p.handle, title: p.title, url: p.url,
      vid: v.id, sku: v.sku, size: v.size, metal: v.metalValue, price: v.price,
      img: v.image || imagesFor(p, v.metal || this.metal)[0] || '', needsSize: false
    };
  };

  /* for Best sellers / Shuffle: never guesses a size – multi-size pieces ask for one */
  proto.autoPiece = function (p) {
    var metal = this.metal;
    var list = variantsFor(p, metal).filter(function (v) { return v.available; });
    if (!list.length && p.hasMetal) {
      metal = metal === 'gold' ? 'silver' : 'gold';
      list = variantsFor(p, metal).filter(function (v) { return v.available; });
    }
    if (!list.length) list = p.variants.filter(function (v) { return v.available; });
    if (!list.length) return null;
    var piece = this.pieceFrom(p, list[0]);
    if (sizeRange(list).length > 1) {
      piece.size = null;
      piece.needsSize = true;
      piece.price = lowestPrice(list);
    }
    return piece;
  };

  proto.placePiece = function (p, v, slot) {
    var wasSwap = this.swapping > -1;
    var old = this.slots[slot];
    this.slots[slot] = this.pieceFrom(p, v);
    this.swapping = -1;
    this.active = this.firstEmpty();
    this.newSlot = slot;
    this.afterChange();
    this.renderSwapbar();
    var msg = wasSwap && old ? tpl(this.i18n.swapped, { title: old.title }) : tpl(this.i18n.addedToBundle, { title: p.title });
    this.say(msg);
    if (this.count() === this.required) {
      this.flash(this.pendingSizes() ? tpl(this.i18n.ctaSizes, { count: this.pendingSizes() }) : this.i18n.complete, 'ok');
      if (this.pickerOpen) {
        var self = this;
        setTimeout(function () { self.closePicker(); }, 350);
      }
    }
  };

  proto.pickSlot = function (idx) {
    this.closeMenus();
    if (this.swapping > -1) this.cancelSwap(true);
    this.active = idx;
    this.renderSlots();
    this.openPicker();
  };

  proto.removeSlot = function (idx) {
    var s = this.slots[idx];
    if (!s) return;
    this.slots[idx] = null;
    if (this.swapping === idx) this.swapping = -1;
    this.active = idx;
    this.afterChange();
    this.renderSwapbar();
    this.say(tpl(this.i18n.removedPiece, { title: s.title }));
    var btn = this.el.slots.children[idx] && this.el.slots.children[idx].querySelector('[data-act="empty"]');
    if (btn) btn.focus();
  };

  proto.startSwap = function (idx) {
    if (!this.slots[idx]) return;
    this.closeMenus();
    this.swapping = idx;
    this.active = idx;
    this.renderSlots();
    this.renderSwapbar();
    this.say(tpl(this.i18n.swapBanner, { title: this.slots[idx].title }));
    this.openPicker();
  };

  proto.cancelSwap = function (quiet) {
    this.swapping = -1;
    this.active = this.firstEmpty();
    this.renderSlots();
    this.renderSwapbar();
    if (!quiet && this.el.slots) {
      var b = this.el.slots.querySelector('[data-act="menu"]');
      if (b) b.focus();
    }
  };

  proto.renderSwapbar = function () {
    if (!this.el.swapbar) return;
    var s = this.swapping > -1 ? this.slots[this.swapping] : null;
    this.el.swapbar.hidden = !s;
    if (s && this.el.swapText) this.el.swapText.textContent = tpl(this.i18n.swapBanner, { title: s.title });
  };

  /* ------------------------------------------------------------------ */
  /* slots + price                                                      */
  /* ------------------------------------------------------------------ */
  proto.canChangeSize = function (s) {
    var p = this.byId[s.pid];
    if (s.needsSize) return true;
    if (p) {
      var metal = null;
      p.variants.forEach(function (v) { if (String(v.id) === String(s.vid)) metal = v.metal; });
      return sizeRange(variantsFor(p, metal)).length > 1;
    }
    return !!s.size;
  };

  proto.renderSlots = function () {
    var box = this.el.slots;
    if (!box) return;
    var self = this;
    var html = '';
    this.slots.forEach(function (s, i) {
      var n = i + 1;
      if (!s) {
        var on = i === self.active && self.swapping < 0;
        html += '<li class="rbb-slot' + (on ? ' is-active' : '') + '">' +
          '<button type="button" class="rbb-slot__pick" data-act="empty" data-idx="' + i + '" aria-label="' + esc(tpl(self.i18n.emptySlot, { number: n })) + '">' +
          '<span class="rbb-slot__plus" aria-hidden="true">+</span></button></li>';
        return;
      }
      var tag = s.needsSize ? self.i18n.needsSize : (s.size ? tpl(self.i18n.sizeLabel, { size: s.size }) : self.i18n.oneSize);
      var menu = '';
      if (self.openMenu === i) {
        menu = '<div class="rbb-slot__menu">' +
          (self.canChangeSize(s) ? '<button type="button" data-act="size" data-idx="' + i + '" aria-label="' + esc((s.needsSize ? self.i18n.chooseSize : self.i18n.changeSize) + ': ' + s.title) + '">' + esc(self.i18n.slotSize) + '</button>' : '') +
          '<button type="button" data-act="swap" data-idx="' + i + '" aria-label="' + esc(self.i18n.swapPiece + ': ' + s.title) + '">' + esc(self.i18n.slotSwap) + '</button>' +
          '<button type="button" class="is-danger" data-act="remove" data-idx="' + i + '" aria-label="' + esc(self.i18n.removePiece + ': ' + s.title) + '">' + esc(self.i18n.slotRemove) + '</button>' +
          '</div>';
      }
      html += '<li class="rbb-slot is-filled' + (s.needsSize ? ' needs-size' : '') + (self.swapping === i ? ' is-active' : '') + (self.newSlot === i ? ' is-new' : '') + '">' +
        (s.img ? '<img src="' + esc(imgSize(s.img, 240)) + '" alt="" loading="lazy" width="120" height="150">' : '') +
        '<span class="rbb-slot__tag">' + esc(tag) + '</span>' +
        '<span class="rbb-sr">' + esc(tpl(self.i18n.filledSlot, { title: s.title, number: n })) + '</span>' +
        (s.needsSize ? '<button type="button" class="rbb-slot__size" data-act="size" data-idx="' + i + '" aria-label="' + esc(self.i18n.chooseSize + ': ' + s.title) + '"></button>' : '') +
        '<button type="button" class="rbb-slot__edit" data-act="menu" data-idx="' + i + '" aria-expanded="' + (self.openMenu === i) + '" aria-label="' + esc(tpl(self.i18n.editPiece, { title: s.title })) + '">' +
          '<svg width="11" height="11" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M8.5 1.5l2 2L4 10H2V8z" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>' +
        '</button>' + menu + '</li>';
    });
    box.innerHTML = html;
    this.newSlot = -1;
    var c = this.count() + '/' + this.required;
    if (this.el.count) this.el.count.textContent = c;
    if (this.el.sheetCount) this.el.sheetCount.textContent = c;
  };

  proto.toggleMenu = function (idx) {
    this.openMenu = this.openMenu === idx ? -1 : idx;
    this.renderSlots();
    var first = this.el.slots.querySelector('.rbb-slot__menu button');
    if (first) first.focus();
  };

  proto.closeMenus = function () {
    if (this.openMenu > -1) { this.openMenu = -1; this.renderSlots(); }
  };

  proto.renderPrice = function () {
    var b = this.cfg.bundle;
    var n = this.count();
    var retail = this.retailTotal();
    var left = this.required - n;
    var pending = this.pendingSizes();
    if (this.el.retail) {
      this.el.retail.textContent = this.money.format(retail, true);
      this.el.retail.hidden = !(n > 0 && retail > b.price);
    }
    if (this.el.price) this.el.price.textContent = this.money.format(b.price, true);
    if (this.el.save) {
      var saving = n > 0 && retail > b.price ? retail - b.price : 0;
      this.el.save.hidden = !saving;
      if (saving) this.el.save.textContent = tpl(this.i18n.save, { amount: this.money.format(saving, true) });
    }
    var cta = this.el.cta;
    if (cta) {
      if (left > 0) {
        cta.disabled = true;
        cta.textContent = (this.i18n.ctaMore || [])[left] || '';
      } else if (pending > 0) {
        cta.disabled = false;
        cta.textContent = tpl(this.i18n.ctaSizes, { count: pending });
      } else {
        cta.disabled = !b.available;
        cta.textContent = b.available ? tpl(this.i18n.ctaReady, { price: this.money.format(b.price, true) }) : this.i18n.bundleSoldOut;
      }
    }
  };

  /* ------------------------------------------------------------------ */
  /* size pop-up + ring size guide                                      */
  /* ------------------------------------------------------------------ */
  proto.fetchProduct = function (handle) {
    var self = this;
    var root = this.cfg.rootUrl || '';
    return fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        var raw = {
          id: d.id, h: d.handle, t: d.title, u: d.url, tg: d.tags || [], a: d.available, ts: '', gc: false,
          o: (d.options || []).map(function (o) { return o.name || o; }),
          im: (d.images || []).slice(0, 2).map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; }),
          v: (d.variants || []).map(function (v) {
            return { id: v.id, p: v.price, a: v.available, k: v.sku, o: v.options || [v.option1, v.option2, v.option3], i: v.featured_image ? v.featured_image.src : null };
          })
        };
        var p = normalizeProduct(raw);
        self.byId[p.id] = p;
        return p;
      });
  };

  proto.openSizeFor = function (idx, opener) {
    var s = this.slots[idx];
    if (!s) return;
    var self = this;
    var go = function (p) {
      var v0 = null;
      p.variants.forEach(function (v) { if (String(v.id) === String(s.vid)) v0 = v; });
      var metal = v0 ? v0.metal : null;
      self.openSizeModal(p, { slot: idx, variants: variantsFor(p, metal), current: s.needsSize ? null : s.size, opener: opener, update: true });
    };
    var p = this.byId[s.pid];
    if (p) go(p);
    else this.fetchProduct(s.handle).then(go).catch(function () { self.flash(self.i18n.loadError, 'error'); });
  };

  proto.openSizeModal = function (p, ctx) {
    var modal = this.q('[data-modal="size"]');
    if (!modal) return;
    this.sizeCtx = ctx;
    this.sizeCtx.product = p;
    this.sizeCtx.vid = null;

    var img = modal.querySelector('[data-szp-img]');
    var first = ctx.variants.filter(function (v) { return v.image; })[0];
    var src = first ? first.image : (p.images[0] || '');
    if (img) { img.src = imgSize(src, 160); img.alt = ''; }
    var name = modal.querySelector('[data-szp-name]');
    if (name) name.textContent = p.title;

    var sizes = modal.querySelector('[data-szp-sizes]');
    var self = this;
    var html = '';
    var seen = {};
    ctx.variants.forEach(function (v) {
      if (!v.size || seen[v.size]) return;
      seen[v.size] = 1;
      var on = ctx.current && v.size === ctx.current;
      if (on) self.sizeCtx.vid = String(v.id);
      html += '<button type="button" role="radio" aria-checked="' + (on ? 'true' : 'false') + '" data-size-vid="' + esc(v.id) + '"' +
        (v.available ? '' : ' disabled aria-label="' + esc(v.size + ' – ' + self.i18n.sizeSoldOut) + '"') + '>' + esc(v.size) + '</button>';
    });
    sizes.innerHTML = html;

    var guide = modal.querySelector('[data-szp-guide]');
    if (guide) {
      var cats = this.cfg.categories || [];
      var cat = p.cat !== null && cats[p.cat] ? cats[p.cat] : null;
      var numeric = Object.keys(seen).length > 0 && Object.keys(seen).every(function (s) { return /^\d+([.,]\d+)?$/.test(String(s).trim()); });
      var allowed = cat ? cat.guide !== false : true;
      var url = cat && cat.guideUrl ? cat.guideUrl : '';
      var show = allowed && numeric && (url || this.cfg.hasGuide);
      guide.hidden = !show;
      guide.textContent = (cat && cat.guideText) || this.i18n.ringGuide;
      guide.setAttribute('data-url', url);
    }
    this.syncSizeSave();
    this.showModal(modal, ctx.opener);
    var focus = sizes.querySelector('[aria-checked="true"]') || sizes.querySelector('button:not(:disabled)');
    if (focus) focus.focus();
  };

  proto.chooseSize = function (vid) {
    if (!this.sizeCtx) return;
    this.sizeCtx.vid = String(vid);
    toArray(this.querySelectorAll('[data-szp-sizes] [data-size-vid]')).forEach(function (b) {
      b.setAttribute('aria-checked', b.getAttribute('data-size-vid') === String(vid) ? 'true' : 'false');
    });
    this.syncSizeSave();
  };

  proto.syncSizeSave = function () {
    var save = this.q('[data-szp-save]');
    var ctx = this.sizeCtx;
    if (!save || !ctx) return;
    var v = null;
    ctx.variants.forEach(function (x) { if (String(x.id) === ctx.vid) v = x; });
    save.disabled = !v;
    save.textContent = v ? tpl(ctx.update ? this.i18n.sizeSave : this.i18n.sizeAdd, { size: v.size }) : this.i18n.sizeChoose;
  };

  proto.saveSize = function () {
    var ctx = this.sizeCtx;
    if (!ctx || !ctx.vid) return;
    var v = null;
    ctx.variants.forEach(function (x) { if (String(x.id) === ctx.vid) v = x; });
    if (!v) return;
    var modal = this.q('[data-modal="size"]');
    this.sizeCtx = null;
    ctx.opener = null;
    this.closeModal(modal);
    var s = this.slots[ctx.slot];
    if (ctx.update && s && String(s.pid) === String(ctx.product.id)) {
      s.vid = v.id; s.size = v.size; s.sku = v.sku; s.price = v.price; s.needsSize = false;
      if (v.image) s.img = v.image;
      this.newSlot = ctx.slot;
      this.afterChange();
      this.say(tpl(this.i18n.sizeLabel, { size: v.size }) + ' · ' + s.title);
      if (this.isComplete()) this.flash(this.i18n.complete, 'ok');
      var next = this.el.slots && this.el.slots.children[ctx.slot] && this.el.slots.children[ctx.slot].querySelector('[data-act]');
      if (next) next.focus();
    } else {
      this.placePiece(ctx.product, v, ctx.slot);
    }
  };

  proto.openGuide = function (btn) {
    var url = btn.getAttribute('data-url');
    if (url) { window.open(url, '_blank', 'noopener'); return; }
    var modal = this.q('[data-modal="guide"]');
    if (!modal) return;
    this.updateGuideBack();
    this.showModal(modal, btn);
  };

  /* ---------------- ring size guide: ring (inner diameter) or finger (circumference), mm or inches ---------------- */
  proto.initGuide = function () {
    var modal = this.q('[data-modal="guide"]');
    if (!modal) return;
    var self = this;
    this.guide = { modal: modal, mode: 'ring', unit: 'mm', chart: parseChart(this.cfg.guideChart), pick: null, vid: null };
    if (!this.guide.chart.length) this.guide.chart = parseChart('8=48;10=50;12=52;14=54;16=56;18=58;20=60;22=62;24=64');
    this.guide.input = modal.querySelector('[data-calc-input]');
    modal.addEventListener('click', function (e) {
      var m = e.target.closest('[data-guide-mode]');
      if (m) { self.setGuideMode(m.getAttribute('data-guide-mode')); return; }
      var u = e.target.closest('[data-guide-unit]');
      if (u) self.setGuideUnit(u.getAttribute('data-guide-unit'));
    });
    var modes = modal.querySelector('.rbb-guide__modes');
    if (modes) modes.addEventListener('keydown', function (e) {
      self.tabKeys(e, '[data-guide-mode]', function (b) { self.setGuideMode(b.getAttribute('data-guide-mode')); });
    });
    if (this.guide.input) this.guide.input.addEventListener('input', function () { self.calcGuide(); });
    this.renderGuide();
  };

  /* mm: 1 decimal, no trailing .0 (48, 15.3). inches: 2 decimals (1.89) */
  proto.guideFmt = function (mm, unit) {
    if (unit === 'in') return (mm / 25.4).toFixed(2);
    return (Math.round(mm * 10) / 10).toFixed(1).replace(/\.0$/, '');
  };

  /* what a chart row shows: finger circumference, or the inner diameter of a ring (circumference / pi) */
  proto.guideValue = function (row, mode) { return mode === 'finger' ? row.c : row.c / Math.PI; };

  proto.setGuideMode = function (mode) {
    if (!this.guide || this.guide.mode === mode) return;
    this.guide.mode = mode;
    if (this.guide.input) this.guide.input.value = '';
    this.renderGuide();
  };

  proto.setGuideUnit = function (unit) {
    var g = this.guide;
    if (!g || g.unit === unit) return;
    var v = g.input ? parseFloat(String(g.input.value).replace(',', '.')) : NaN;
    if (v > 0) g.input.value = unit === 'in' ? (v / 25.4).toFixed(2) : (v * 25.4).toFixed(1);
    g.unit = unit;
    this.renderGuide();
  };

  proto.renderGuide = function () {
    var g = this.guide;
    if (!g) return;
    var self = this;
    var modal = g.modal;
    var unitLabel = g.unit === 'in' ? this.i18n.gIn : this.i18n.gMm;
    toArray(modal.querySelectorAll('[data-guide-mode]')).forEach(function (b) {
      var on = b.getAttribute('data-guide-mode') === g.mode;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    toArray(modal.querySelectorAll('[data-guide-show]')).forEach(function (el) {
      /* setAttribute, not .hidden: the drawings are SVG elements, which have no .hidden property */
      if (el.getAttribute('data-guide-show') === g.mode) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    toArray(modal.querySelectorAll('[data-guide-unit]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-guide-unit') === g.unit ? 'true' : 'false');
    });
    var label = tpl(g.mode === 'finger' ? this.i18n.gCircumference : this.i18n.gDiameter, { unit: unitLabel });
    var lab = modal.querySelector('[data-calc-label]');
    if (lab) lab.textContent = label;
    var col = modal.querySelector('[data-table-col]');
    if (col) col.textContent = label;
    var unitEl = modal.querySelector('[data-calc-unit]');
    if (unitEl) unitEl.textContent = unitLabel;
    var mid = g.chart[Math.floor((g.chart.length - 1) / 2)] || { c: 56 };
    if (g.input) g.input.placeholder = tpl(this.i18n.gExample, { value: this.guideFmt(this.guideValue(mid, g.mode), g.unit) });
    var body = modal.querySelector('[data-table-body]');
    if (body) {
      body.innerHTML = g.chart.map(function (r) {
        return '<tr' + (g.pick === r.size ? ' class="is-match"' : '') + '><td>' + esc(self.guideFmt(self.guideValue(r, g.mode), g.unit)) + '</td><td>' + esc(r.size) + '</td></tr>';
      }).join('');
    }
    this.calcGuide();
  };

  proto.calcGuide = function () {
    var g = this.guide;
    if (!g || !g.input) return;
    var out = g.modal.querySelector('[data-calc-result]');
    var raw = String(g.input.value).replace(',', '.').trim();
    var v = parseFloat(raw);
    var text = '—';
    g.pick = null;
    if (raw && v > 0) {
      var mm = g.unit === 'in' ? v * 25.4 : v;
      /* everything is compared as finger circumference in mm */
      var c = g.mode === 'finger' ? mm : mm * Math.PI;
      var first = g.chart[0], last = g.chart[g.chart.length - 1];
      var step = g.chart.length > 1 ? g.chart[1].c - first.c : 2;
      var tol = 0.5; /* within half a mm of a size counts as that size; beyond it, go up a size */
      if (c < first.c - step) text = tpl(this.i18n.gSmaller, { size: first.size });
      else if (c > last.c + tol) text = tpl(this.i18n.gLarger, { size: last.size });
      else {
        for (var i = 0; i < g.chart.length; i++) {
          if (g.chart[i].c >= c - tol) { g.pick = g.chart[i].size; break; }
        }
        text = g.pick || '—';
      }
    }
    if (out) out.textContent = text;
    toArray(g.modal.querySelectorAll('[data-table-body] tr')).forEach(function (tr, i) {
      tr.classList.toggle('is-match', !!g.pick && g.chart[i] && g.chart[i].size === g.pick);
    });
    this.updateGuideBack();
  };

  /* "Select size 8" when the measured size exists (and is in stock) on the piece being sized.
     Only for pieces whose sizes all appear in the chart, so other size systems are never mapped. */
  proto.updateGuideBack = function () {
    var g = this.guide;
    if (!g) return;
    var back = g.modal.querySelector('[data-guide-back]');
    var ctx = this.sizeCtx;
    g.vid = null;
    if (g.pick && ctx && ctx.variants) {
      var chartSizes = g.chart.map(function (r) { return r.size; });
      var sized = ctx.variants.filter(function (v) { return v.size; });
      var allInChart = sized.length > 0 && sized.every(function (v) { return chartSizes.indexOf(String(v.size).trim()) > -1; });
      if (allInChart) {
        sized.forEach(function (v) { if (!g.vid && v.available && String(v.size).trim() === g.pick) g.vid = String(v.id); });
      }
    }
    if (back) back.textContent = g.vid ? tpl(this.i18n.gUseSize, { size: g.pick }) : this.i18n.backToSizes;
  };

  proto.guideBack = function () {
    var g = this.guide;
    var vid = g && g.vid;
    this.closeModal(g ? g.modal : this.q('[data-modal="guide"]'));
    if (vid && this.sizeCtx) {
      this.chooseSize(vid);
      var save = this.q('[data-szp-save]');
      if (save) save.focus();
    }
  };

  /* ------------------------------------------------------------------ */
  /* Pick my own / Best sellers / Shuffle / Undo / Clear                */
  /* ------------------------------------------------------------------ */
  proto.renderModes = function () {
    var self = this;
    toArray(this.querySelectorAll('[data-mode]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mode') === self.mode ? 'true' : 'false');
    });
    var undo = this.history.length > 0;
    var any = this.count() > 0;
    if (this.el.undo) this.el.undo.hidden = !undo;
    if (this.el.clear) this.el.clear.hidden = !any;
    if (this.el.tools) this.el.tools.hidden = !(undo || any);
  };

  proto.snapshot = function () {
    this.history.push({ slots: JSON.parse(JSON.stringify(this.slots)), mode: this.mode });
    if (this.history.length > HISTORY_MAX) this.history.shift();
  };

  proto.undo = function () {
    var snap = this.history.pop();
    if (!snap) return;
    this.slots = snap.slots;
    this.mode = snap.mode;
    this.swapping = -1;
    this.openMenu = -1;
    this.active = this.firstEmpty();
    this.afterChange();
    this.renderSwapbar();
    this.say(this.i18n.undone);
    this.flash(this.i18n.undone, 'ok');
  };

  proto.clearSlots = function () {
    if (!this.count()) return;
    this.snapshot();
    for (var i = 0; i < this.slots.length; i++) this.slots[i] = null;
    this.swapping = -1;
    this.openMenu = -1;
    this.active = 0;
    this.mode = 'pick';
    this.afterChange();
    this.renderSwapbar();
    this.say(this.i18n.cleared);
  };

  proto.confirmClear = function (onKeep, onClear) {
    var modal = this.q('[data-modal="clear"]');
    if (!modal) { if (onClear) onClear(); return; }
    this._clearCb = { keep: onKeep, clear: onClear };
    this.showModal(modal, document.activeElement);
    var keep = modal.querySelector('[data-clear-keep]');
    if (keep) keep.focus();
  };

  proto.resolveClear = function (doClear) {
    var cb = this._clearCb || {};
    this._clearCb = null;
    var modal = this.q('[data-modal="clear"]');
    if (modal) modal._opener = null;
    this.closeModal(modal);
    if (doClear) { if (cb.clear) cb.clear(); }
    else if (cb.keep) cb.keep();
  };

  proto.pickOwn = function () {
    var self = this;
    if (this.mode !== 'pick' && this.count() > 0) {
      this.confirmClear(function () {
        self.mode = 'pick';
        self.persist();
        self.renderModes();
        self.openPicker();
      }, function () {
        self.clearSlots();
        self.openPicker();
      });
      return;
    }
    this.mode = 'pick';
    this.persist();
    this.renderModes();
    this.openPicker();
  };

  proto.setModeBusy = function (btn, on) {
    this._modeBusy = on;
    if (btn) btn.classList.toggle('is-busy', on);
    if (on) this.flash(this.i18n.loadingPieces);
  };

  proto.applyPicks = function (picks, mode, message) {
    if (!picks.length) { this.flash(this.i18n.loadError, 'error'); return; }
    this.snapshot();
    for (var i = 0; i < this.required; i++) this.slots[i] = picks[i] || null;
    this.mode = mode;
    this.swapping = -1;
    this.openMenu = -1;
    this.active = this.firstEmpty();
    this.afterChange();
    this.renderSwapbar();
    var pending = this.pendingSizes();
    this.say(message);
    this.flash(pending ? message + ' · ' + tpl(this.i18n.ctaSizes, { count: pending }) : message, 'ok');
  };

  /* Best sellers: the "Best sellers" collection's order, but only pieces that are in one of
     the bundle's category tabs (so no hats, belts…); topped up with each tab's best sellers */
  proto.fillBest = function (btn) {
    if (this._modeBusy) return;
    var self = this;
    this.setModeBusy(btn, true);
    var best = !this.cfg.bestUrl ? Promise.resolve([]) :
      this.pool.best ? Promise.resolve(this.pool.best) :
      this.loadPage(this.cfg.bestUrl, 1).then(function (data) {
        var list = [];
        (data.products || []).forEach(function (raw) {
          if (!raw || !raw.v || !raw.v.length) return;
          var p = self.byId[raw.id] || normalizeProduct(raw);
          self.byId[p.id] = p;
          list.push(p);
        });
        self.pool.best = list;
        return list;
      }).catch(function () { return []; });

    Promise.all([this.loadAllCategories(), best]).then(function (res) {
      var pool = (res[1] || []).filter(function (p) { return p.cat !== null; });
      var lists = (self.cfg.categories || []).map(function (c, i) { return (self.products[i] || { list: [] }).list.slice(); });
      var more = true;
      while (more) {
        more = false;
        lists.forEach(function (l) { if (l.length) { pool.push(l.shift()); more = true; } });
      }
      var picks = [], used = {};
      pool.forEach(function (p) {
        if (picks.length >= self.required || used[p.id] || !self.eligible(p)) return;
        var piece = self.autoPiece(p);
        if (piece) { used[p.id] = 1; picks.push(piece); }
      });
      self.applyPicks(picks, 'best', self.i18n.bestLoaded);
    }).catch(function () {
      self.flash(self.i18n.loadError, 'error');
    }).then(function () { self.setModeBusy(btn, false); });
  };

  proto.shuffle = function (btn) {
    if (this._modeBusy) return;
    var self = this;
    this.setModeBusy(btn, true);
    this.loadAllCategories().then(function () {
      var cats = self.cfg.categories || [];
      var buckets = cats.map(function (c, i) {
        return shuffled(((self.products[i] || { list: [] }).list).filter(function (p) { return self.eligible(p); }));
      });
      var order = shuffled(cats.map(function (c, i) { return i; }).filter(function (i) { return buckets[i].length; }));
      var picks = [], used = {};
      var progressed = true;
      while (picks.length < self.required && progressed) {
        progressed = false;
        for (var k = 0; k < order.length && picks.length < self.required; k++) {
          var bucket = buckets[order[k]];
          while (bucket.length) {
            var p = bucket.pop();
            if (used[p.id]) continue;
            var piece = self.autoPiece(p);
            if (piece) { used[p.id] = 1; picks.push(piece); progressed = true; break; }
          }
        }
        order = shuffled(order);
      }
      self.applyPicks(shuffled(picks), 'shuffle', self.i18n.shuffled);
    }).catch(function () {
      self.flash(self.i18n.loadError, 'error');
    }).then(function () { self.setModeBusy(btn, false); });
  };

  /* ------------------------------------------------------------------ */
  /* picker sheet (mobile) / scroll (desktop)                           */
  /* ------------------------------------------------------------------ */
  proto.openPicker = function () {
    if (!this.el.picker) return;
    if (!this.isMobile()) { this.scrollToGrid(); return; }
    this._pickerOpener = document.activeElement;
    this.el.picker.classList.add('is-open');
    this.el.picker.setAttribute('role', 'dialog');
    this.el.picker.setAttribute('aria-modal', 'true');
    this.pickerOpen = true;
    this.lockCheck();
    var close = this.el.picker.querySelector('.rbb-picker__close');
    if (close) setTimeout(function () { close.focus(); }, 40);
  };

  proto.closePicker = function (silent) {
    if (!this.pickerOpen) return;
    this.el.picker.classList.remove('is-open');
    this.el.picker.removeAttribute('role');
    this.el.picker.removeAttribute('aria-modal');
    this.pickerOpen = false;
    if (this.swapping > -1) this.cancelSwap(true);
    this.lockCheck();
    var back = this._pickerOpener;
    this._pickerOpener = null;
    if (!silent && back && document.contains(back) && back.focus) back.focus();
  };

  proto.scrollToGrid = function () {
    var target = this.el.picker;
    if (!target) return;
    var rect = target.getBoundingClientRect();
    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 70;
    if (rect.top < header || rect.top > window.innerHeight * 0.6) {
      window.scrollTo({ top: window.pageYOffset + rect.top - header - 12, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  };

  /* ------------------------------------------------------------------ */
  /* modals                                                             */
  /* ------------------------------------------------------------------ */
  proto.showModal = function (modal, opener) {
    if (!modal) return;
    if (this.modalStack.indexOf(modal) < 0) this.modalStack.push(modal);
    modal._opener = opener || document.activeElement;
    modal.hidden = false;
    this.lockCheck();
    var panel = modal.querySelector('.rbb-modal__panel');
    if (panel && !panel.contains(document.activeElement)) {
      var f = panel.querySelector('button:not(:disabled), [href], [tabindex]:not([tabindex="-1"])');
      if (f) f.focus();
    }
  };

  proto.closeModal = function (modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    this.modalStack = this.modalStack.filter(function (m) { return m !== modal; });
    this.lockCheck();
    if (modal.getAttribute('data-modal') === 'size') this.sizeCtx = null;
    if (modal.getAttribute('data-modal') === 'clear') this._clearCb = null;
    var back = modal._opener;
    modal._opener = null;
    if (back && document.contains(back) && back.focus && back.offsetParent !== null) back.focus();
  };

  proto.openReviews = function (opener) {
    var modal = this.q('[data-modal="reviews"]');
    var list = modal && modal.querySelector('[data-rv-list]');
    var track = this.q('[data-rv-track]');
    if (!modal || !list || !track) return;
    if (!list.children.length) list.innerHTML = track.innerHTML;
    this.showModal(modal, opener);
  };

  /* ------------------------------------------------------------------ */
  /* steps                                                              */
  /* ------------------------------------------------------------------ */
  proto.showExtras = function (push) {
    if (!this.cfg.box || !this.el.extras) return;
    this.closePicker(true);
    this.renderExtras();
    this.el.build.hidden = true;
    this.el.extras.hidden = false;
    if (push && window.history && window.location.hash !== '#extras') {
      try { window.history.pushState({ rbb: 'extras' }, '', '#extras'); } catch (e) {}
    }
    if (this._syncBar) this._syncBar();
    this.scrollToTop();
    var h = this.el.extras.querySelector('.rbb-extras__title');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  };

  proto.showBuild = function (fromUser) {
    if (!this.el.build) return;
    var wasExtras = this.el.extras && !this.el.extras.hidden;
    if (this.el.extras) this.el.extras.hidden = true;
    this.el.build.hidden = false;
    if (this._dockUpdate) this._dockUpdate();
    if (fromUser && window.location.hash === '#extras') {
      try { window.history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
    }
    if (wasExtras) this.scrollToTop();
  };

  proto.scrollToTop = function () {
    var rect = this.getBoundingClientRect();
    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    window.scrollTo({ top: Math.max(0, window.pageYOffset + rect.top - header), behavior: 'auto' });
  };

  proto.renderExtras = function () {
    var self = this;
    var b = this.cfg.bundle;
    var thumbs = this.q('[data-sorted-thumbs]');
    if (thumbs) {
      thumbs.innerHTML = this.slots.map(function (s) {
        if (!s) return '';
        return '<li title="' + esc(s.title) + '">' + (s.img ? '<img src="' + esc(imgSize(s.img, 160)) + '" alt="' + esc(s.title) + '" loading="lazy" width="52" height="65">' : '') + '</li>';
      }).join('');
    }
    var retail = this.retailTotal();
    var xr = this.q('[data-x-retail]');
    if (xr) xr.textContent = retail > b.price ? this.money.format(retail) : '';
    var xp = this.q('[data-x-price]');
    if (xp) xp.textContent = this.money.format(b.price);
    var xs = this.q('[data-x-saved]');
    if (xs) {
      xs.hidden = !(retail > b.price);
      xs.textContent = tpl(this.i18n.saved, { amount: this.money.format(retail - b.price, true) });
    }

    var box = this.cfg.box;
    if (!box) return;
    var colors = this.q('[data-box-colors]');
    if (!this.boxVariant) {
      this.boxVariant = box.variants.filter(function (v) { return v.available; })[0] || box.variants[0];
    }
    if (colors && box.variants.length > 1) {
      colors.innerHTML = box.variants.map(function (v) {
        var on = self.boxVariant && String(v.id) === String(self.boxVariant.id);
        return '<button type="button" role="radio" aria-checked="' + on + '" data-vid="' + esc(v.id) + '"' + (v.available ? '' : ' class="is-soldout"') + '>' + esc(v.color || v.title) + '</button>';
      }).join('');
    }
    this.renderBoxPrice();
  };

  proto.selectBoxVariant = function (vid) {
    var box = this.cfg.box;
    var v = box.variants.filter(function (x) { return String(x.id) === String(vid); })[0];
    if (!v) return;
    this.boxVariant = v;
    toArray(this.querySelectorAll('[data-box-colors] [data-vid]')).forEach(function (b) {
      b.setAttribute('aria-checked', b.getAttribute('data-vid') === String(vid) ? 'true' : 'false');
    });
    var main = this.q('[data-box-media] .rbb-box__img img');
    if (main && v.image) { main.removeAttribute('srcset'); main.src = v.image; }
    this.renderBoxPrice();
  };

  proto.renderBoxPrice = function () {
    var v = this.boxVariant;
    if (!v) return;
    var now = this.q('[data-box-now]');
    var cmp = this.q('[data-box-compare]');
    var off = this.q('[data-box-off]');
    if (now) now.textContent = this.money.format(v.price);
    var hasCmp = v.compare && v.compare > v.price;
    if (cmp) cmp.textContent = hasCmp ? this.money.format(v.compare) : '';
    if (off) {
      off.hidden = !hasCmp;
      if (hasCmp) off.textContent = tpl(this.i18n.boxOff, { percent: Math.round((1 - v.price / v.compare) * 100) });
    }
    if (this.el.addBox && !this.busy) {
      this.el.addBox.disabled = !v.available;
      this.el.addBox.textContent = v.available ? tpl(this.i18n.addBox, { price: this.money.format(v.price, true) }) : this.i18n.boxSoldOut;
    }
  };

  /* ------------------------------------------------------------------ */
  /* checkout                                                           */
  /* ------------------------------------------------------------------ */
  proto.duplicates = function () {
    var seen = {}, out = [];
    this.slots.forEach(function (s) {
      if (!s) return;
      var key = String(s.pid);
      seen[key] = seen[key] || { title: s.title, n: 0 };
      seen[key].n++;
    });
    Object.keys(seen).forEach(function (k) { if (seen[k].n > 1) out.push(seen[k]); });
    return out;
  };

  proto.beforeCheckout = function (withBox, trigger) {
    if (this.busy) return;
    if (!this.isComplete()) { this.showBuild(true); this.flash(this.i18n.incomplete, 'error'); return; }
    var dupes = this.cfg.checkDupes ? this.duplicates() : [];
    if (dupes.length) {
      this._pendingBox = withBox;
      this._pendingTrigger = trigger;
      var list = this.q('[data-dupe-list]');
      if (list) list.innerHTML = dupes.map(function (d) { return '<li>' + esc(d.title) + ' ×' + d.n + '</li>'; }).join('');
      this.showModal(this.q('[data-modal="dupes"]'), trigger);
      return;
    }
    this.addToCart(withBox, trigger);
  };

  proto.cartItems = function (withBox) {
    var b = this.cfg.bundle;
    var props = { _bundle: '1', _bundle_count: String(this.required) };
    this.slots.forEach(function (s, i) {
      var n = i + 1;
      var bits = [s.title];
      if (s.metal) bits.push(s.metal);
      if (s.size) bits.push('Size ' + s.size);
      props['Piece ' + n] = bits.join(' · ');
      props['_p' + n] = [s.handle, s.vid, s.metal || '', s.size || ''].join('|');
    });
    var items = [{ id: b.variantId, quantity: 1, properties: props }];
    if (withBox && this.boxVariant) {
      items.push({ id: this.boxVariant.id, quantity: 1, properties: { _bundle_extra: '1' } });
    }
    return items;
  };

  proto.setBusy = function (on, trigger) {
    this.busy = on;
    var self = this;
    [this.el.addBox, this.el.skip, this.el.cta].forEach(function (b) {
      if (!b) return;
      if (on) {
        b.disabled = true;
        if (b === trigger) {
          b.setAttribute('data-label', b.innerHTML);
          b.textContent = self.i18n.adding;
        }
      } else {
        var label = b.getAttribute('data-label');
        if (label !== null) { b.innerHTML = label; b.removeAttribute('data-label'); }
        b.disabled = false;
      }
    });
    if (!on) { this.renderPrice(); this.renderBoxPrice(); }
  };

  proto.showError = function (text) {
    var target = this.el.extras && !this.el.extras.hidden ? this.el.xMsg : this.el.msg;
    if (target === this.el.msg) { this.flash(text, 'error'); }
    else if (target) target.textContent = text;
    this.say(text);
  };

  proto.addToCart = function (withBox, trigger) {
    if (this.busy) return;
    var self = this;
    if (!this.cfg.bundle.available) { this.showError(this.i18n.bundleSoldOut); return; }
    if (this.el.xMsg) this.el.xMsg.textContent = '';
    this.setBusy(true, trigger);

    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 20000);

    fetch(this.cfg.cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: this.cartItems(withBox) }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      return r.text().then(function (t) {
        var data = {};
        try { data = JSON.parse(t); } catch (e) {}
        return { ok: r.ok, data: data };
      });
    }).then(function (res) {
      clearTimeout(timer);
      if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || self.i18n.addFailed);
      self.onAdded();
    }).catch(function (err) {
      clearTimeout(timer);
      self.setBusy(false);
      var text = err && err.name !== 'AbortError' && err.message && err.message.indexOf('HTTP') !== 0 && err.message !== 'Failed to fetch' ? err.message : self.i18n.addFailed;
      self.showError(text);
    });
  };

  proto.onAdded = function () {
    var cfg = this.cfg;
    this.clearStored();
    try { document.dispatchEvent(new CustomEvent('rynor:bundle-added', { detail: { bundle: cfg.bundle.handle } })); } catch (e) {}
    if (cfg.afterAdd === 'checkout') { window.location.assign(cfg.checkoutUrl); return; }
    if (cfg.afterAdd === 'cart' || !hasThemeCart()) { window.location.assign(cfg.cartUrl); return; }

    for (var i = 0; i < this.slots.length; i++) this.slots[i] = null;
    this.history = [];
    this.mode = 'pick';
    this.swapping = -1;
    this.active = 0;
    this.setBusy(false);
    this.afterChange();
    this.renderSwapbar();
    this.showBuild(true);
    this.flash(this.i18n.bundleAdded, 'ok');
    this.say(this.i18n.bundleAdded);
    openThemeCart();
  };

  /* ------------------------------------------------------------------ */
  /* price bar (phone + tablet)                                         */
  /* The price / save / button block (.rbb-side__foot) is position:     */
  /* sticky in the CSS, so the browser itself keeps it on the bottom of */
  /* the screen and drops it back into its spot in the card – never     */
  /* past the card, so never over the footer. This part only measures  */
  /* how far it is floating above that spot and turns the full-width    */
  /* bar back into the card's own bottom over the last DOCK_RANGE px.   */
  /* ------------------------------------------------------------------ */
  var DOCK_RANGE = 80;

  proto.initDock = function () {
    var foot = this.q('.rbb-side__foot');
    var card = this.q('.rbb-side__card');
    if (!foot || !card || !window.requestAnimationFrame) return;
    var root = document.documentElement;
    var raf = 0, ro = null, live = false, stale = true, edge = 0, slack = 0;
    var last = {};

    function put(el, name, value) {
      if (last[name] === value) return;
      last[name] = value;
      if (value === '') el.style.removeProperty(name);
      else el.style.setProperty(name, value);
    }

    /* where the block sits when it's pushed against the top of the card */
    function measure() {
      var cs = getComputedStyle(card), fs = getComputedStyle(foot);
      edge = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.paddingTop) || 0) + (parseFloat(fs.marginTop) || 0);
      slack = parseFloat(fs.paddingBottom) || 0;
    }

    function reset() {
      stale = true;
      if (!live) return;
      live = false;
      foot.classList.remove('is-waiting');
      put(foot, '--rbb-dock', '');
      put(foot, '--rbb-bleed-l', '');
      put(foot, '--rbb-bleed-r', '');
      put(root, 'scroll-padding-bottom', '');
      last.wait = null;
    }

    function update() {
      raf = 0;
      /* phones + tablets only, and only while the build step is on screen */
      if (!mobileMq.matches || !foot.offsetParent) { reset(); return; }
      if (stale) { measure(); stale = false; }
      live = true;
      var f = foot.getBoundingClientRect();
      var c = card.getBoundingClientRect();
      var lift = c.bottom - f.bottom; /* how far the bar floats above its spot (0 = in the card) */
      var dock = lift > 0.5 ? Math.min(1, lift / DOCK_RANGE) : 0;
      /* pressed against the top of the card = it can't reach the bottom of the screen yet.
         Only hide it when that cuts into the button, not just the bar's bottom padding. */
      var wait = lift > 0.5 && f.top <= c.top + edge + 1 && f.bottom - window.innerHeight > slack;
      put(foot, '--rbb-dock', dock.toFixed(3));
      put(foot, '--rbb-bleed-l', Math.ceil(Math.max(0, f.left)) + 'px');
      put(foot, '--rbb-bleed-r', Math.ceil(Math.max(0, root.clientWidth - f.right)) + 'px');
      /* keyboard focus never lands hidden behind the bar */
      put(root, 'scroll-padding-bottom', Math.round(f.height + 12) + 'px');
      if (wait !== last.wait) { last.wait = wait; foot.classList.toggle('is-waiting', wait); }
    }

    function schedule() { if (!raf) raf = window.requestAnimationFrame(update); }
    function remeasure() { stale = true; schedule(); }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', remeasure);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', remeasure);
    else if (mobileMq.addListener) mobileMq.addListener(remeasure);
    if (window.ResizeObserver) { ro = new ResizeObserver(schedule); ro.observe(card); }

    this._dockUpdate = schedule;
    this._dockOff = function () {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', remeasure);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', schedule);
      if (mobileMq.removeEventListener) mobileMq.removeEventListener('change', remeasure);
      else if (mobileMq.removeListener) mobileMq.removeListener(remeasure);
      if (ro) ro.disconnect();
      if (raf) window.cancelAnimationFrame(raf);
      raf = 0;
      reset();
    };

    /* first frame without the fade, so a bar that starts out waiting doesn't flash */
    foot.style.transition = 'none';
    update();
    void foot.offsetWidth;
    foot.style.transition = '';
  };

  window.customElements.define('rynor-bundle-builder', RynorBundleBuilder);
})();
